export interface ConfigModel {
   aiEndpointUrl: string;
   applicationId: string;
   apiRootUrl: string;
   bypassAuth: boolean;
   instrumentationKey: string;
   version: string;
}
